export default "__VITE_ASSET__BNoBv8zm__"